const OUTLINED = {
    backgroundOpacity: 'clear',
    variant: 'outlined',
    bordered: true,
    round: true,
    matchText: true,
};

const FILLED = {
    backgroundOpacity: 'solid',
    variant: 'filled',
    bordered: true,
    round: true,
    matchText: false,
};

const HALO = {
    backgroundOpacity: 'echo',
    variant: 'filled',
    bordered: false,
    round: true,
    matchText: true,
};

const FADED = {
    backgroundOpacity: 'faded',
    variant: 'filled',
    bordered: false,
    round: true,
    matchText: true,
};

const CONTAINED = {
    backgroundOpacity: 'faded',
    variant: 'filled',
    bordered: true,
    round: true,
    matchText: true,
};

const TEXT = {
    backgroundOpacity: 'clear',
    variant: 'filled',
    bordered: false,
    round: true,
    matchText: true,
};

const COMMON_STATUS_CHIP_CONFIG = {
    success: {
        text: {
            color: 'success',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'success',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'success',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'success',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'success',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'success',
            shade: 'main',
            ...FILLED,
        },
    },
    error: {
        text: {
            color: 'error',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'error',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'error',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'error',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'error',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'error',
            shade: 'main',
            ...FILLED,
        },
    },
    warning: {
        text: {
            color: 'warning',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'warning',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'warning',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'warning',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'warning',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'warning',
            shade: 'main',
            ...FILLED,
        },
    },
    info: {
        text: {
            color: 'info',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'info',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'info',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'info',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'info',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'info',
            shade: 'main',
            ...FILLED,
        },
    },
    secondary: {
        text: {
            color: 'secondary',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'secondary',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'secondary',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'secondary',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'secondary',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'secondary',
            shade: 'main',
            ...FILLED,
        },
    },
    primary: {
        text: {
            color: 'primary',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'primary',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'primary',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'primary',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'primary',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'primary',
            shade: 'main',
            ...FILLED,
        },
    },
    pink: {
        text: {
            color: 'pink',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'pink',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'pink',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'pink',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'pink',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'pink',
            shade: 'main',
            ...FILLED,
        },
    },
    yellow: {
        text: {
            color: 'yellow',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'yellow',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'yellow',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'yellow',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'yellow',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'yellow',
            shade: 'main',
            ...FILLED,
        },
    },
    purple: {
        text: {
            color: 'purple',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'purple',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'purple',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'purple',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'purple',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'purple',
            shade: 'main',
            ...FILLED,
        },
    },
    grey: {
        text: {
            color: 'grey',
            shade: 'main',
            ...TEXT,
        },
        outlined: {
            color: 'grey',
            shade: 'main',
            ...OUTLINED,
        },

        halo: {
            color: 'grey',
            shade: 'main',
            ...HALO,
        },

        faded: {
            color: 'grey',
            shade: 'main',
            ...FADED,
        },
        contained: {
            color: 'grey',
            shade: 'main',
            ...CONTAINED,
        },
        filled: {
            color: 'grey',
            shade: 'main',
            ...FILLED,
        },
    },
};

export default COMMON_STATUS_CHIP_CONFIG;
